
import { useState, useEffect } from "react"
import { useNavigate, Link, useLocation } from "react-router-dom"
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Button } from "react-bootstrap"
import Select from "react-select"
import { getDiseasesAction } from "../../../store/actions/DiseasesAction"
import { getBranchesAction } from "../../../store/actions/BranchAction";
import { useDispatch, useSelector } from "react-redux"
import { addAdminUserAction, updateAdminUserAction } from "../../../store/actions/AdminUserAction"
import Loader from "../Common/Loader"
import { getRolesWithModulesAction } from "../../../store/actions/RoleAction"
import { showErrorAlert } from "../../../services/ErrorHandlingService"

const statusOptions = [
  { value: "Active", label: "Active" },
  { value: "Inactive", label: "Inactive" },
]

const AddUser = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()
  const [selectedDiseases, setSelectedDiseases] = useState([])
  const [selectedBranch, setSelectedBranch] = useState(null)
  const [showPassword, setShowPassword] = useState(false);
  const [showCPassword, setShowCPassword] = useState(false);
  // const [enable2FA, setEnable2FA] = useState(false);
  const diseases = useSelector((state) => state.diseases.diseases || [])
  const branches = useSelector((state) => state.branches.branches || [])
  // Editing user data if passed
  const editUser = location.state?.user || null

  const roles = useSelector((state) => state.role.roles)

  const branchOptions = branches.map((b) => ({
    value: b.branch_id,
    label: b.branch_name,
  }))

  useEffect(() => {
    dispatch(getRolesWithModulesAction(false)) // <-- fetch roles when page loads
  }, [dispatch])

  const [user, setUser] = useState({
    role_id: "",
    admin_name: "",
    admin_username: "",
    admin_password: "",
    admin_cpassword: "",
    admin_email: "",
    admin_mobile: "",
    admin_status: "",
    enable_2fa: false // Active or Inactive
  })

  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  const [fetching, setFetching] = useState(false)

  const [errors, setErrors] = useState({})
  const roleOptions = roles
    .filter((role) => role.role_id && role.role_name && role.role_name !== "Doctor") // exclude Doctor
    .map((role) => ({
      value: role.role_id,
      label: role.role_name,
    }))


  const selectedRoleLabel = roleOptions.find(
    (r) => String(r.value) === String(user.role_id)
  )?.label

  const showBranchDropdown = !!selectedRoleLabel

  useEffect(() => {
    dispatch(getDiseasesAction(false))
  }, [dispatch])

  useEffect(() => {
    dispatch(getBranchesAction(false))
  }, [dispatch])

  // Fixed: Better handling of disease loading in edit mode
  useEffect(() => {
    if (editUser) {
      setFetching(true)
      setError("")

      setUser({
        edit_admin_id: editUser.admin_id,
        role_id: editUser.role_id || "",
        admin_name: editUser.admin_name || "",
        admin_username: editUser.admin_username || "",
        admin_password: "",
        admin_cpassword: "",
        admin_email: editUser.admin_email || "",
        admin_mobile: editUser.admin_mobile || "",
        admin_status: editUser.admin_status === "Active" ? "Active" : "Inactive",

        // 🔥 FIX HERE
        enable_2fa: editUser.enable_2fa === "Yes",
      })

      setExtraFields({
        dailyCallingCapacity: editUser.daily_calling_capacity
          ? String(editUser.daily_calling_capacity)
          : "",
        maxActivePatients: editUser.maximum_active_patients
          ? String(editUser.maximum_active_patients)
          : "",
      })

      setFetching(false)
    }
  }, [editUser])
  const isDoctorRole = roles.find(
    (r) => String(r.role_id) === String(editUser?.role_id)
  )?.role_name === "Doctor";


  const [extraFields, setExtraFields] = useState({
    dailyCallingCapacity: "",
    maxActivePatients: "",
  })

  // Fixed: Handle disease selection from the correct data structure
  useEffect(() => {
    if (editUser && diseases.length > 0) {
      // Check if user has diseases assigned (note: API returns "diseses" not "diseases")
      if (editUser.diseses && Array.isArray(editUser.diseses) && editUser.diseses.length > 0) {
        // Extract disease_ids from the diseses array
        const userDiseaseIds = editUser.diseses.map((disease) => String(disease.disease_id))

        console.log("Setting selected diseases from diseses array:", userDiseaseIds) // Debug log
        setSelectedDiseases(userDiseaseIds)
      } else if (editUser.disease_ids) {
        // Fallback: handle old format if disease_ids exists
        let userDiseaseIds = []
        try {
          if (typeof editUser.disease_ids === "string") {
            try {
              userDiseaseIds = JSON.parse(editUser.disease_ids)
            } catch {
              userDiseaseIds = editUser.disease_ids.split(",").map((id) => id.trim())
            }
          } else if (Array.isArray(editUser.disease_ids)) {
            userDiseaseIds = editUser.disease_ids
          } else if (editUser.disease_ids) {
            userDiseaseIds = [editUser.disease_ids]
          }

          const diseaseIdsAsStrings = userDiseaseIds
            .map((id) => String(id).trim())
            .filter((id) => id && id !== "null" && id !== "undefined")

          console.log("Setting selected diseases from disease_ids:", diseaseIdsAsStrings) // Debug log
          setSelectedDiseases(diseaseIdsAsStrings)
        } catch (error) {
          console.error("Error parsing disease_ids:", error, editUser.disease_ids)
          setSelectedDiseases([])
        }
      } else {
        // User has no diseases assigned
        setSelectedDiseases([])
      }
    }
  }, [editUser, diseases])

  useEffect(() => {
    if (editUser && branches.length > 0) {
      const branchId = String(editUser.branch_id)

      const exists = branches.some(
        (b) => String(b.branch_id) === branchId
      )

      if (exists) {
        const branch = branches.find(
          (b) => String(b.branch_id) === String(editUser.branch_id)
        )

        if (branch) {
          setSelectedBranch({
            value: String(branch.branch_id),
            label: branch.branch_name,
          })
        }
      }
    }
  }, [editUser, branches])

  // const handleChange = (e) => {
  //   const { name, value } = e.target
  //   setUser((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }))
  // }
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target

    if (type === "checkbox") {
      setUser((prev) => ({
        ...prev,
        [name]: checked,
      }))

      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }))
    } else {
      setUser((prev) => ({
        ...prev,
        [name]: value,
      }))

      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }))
    }
  }

  const handleRoleChange = (selectedOption) => {
    setUser((prev) => ({
      ...prev,
      role_id: selectedOption ? selectedOption.value : "",
    }))


    setErrors((prev) => ({
      ...prev,
      role_id: "",
    }))

    // Clear selected diseases when role changes and disease dropdown should not show
    const newRoleLabel = selectedOption ? selectedOption.label : ""
    const shouldShowDiseases = ["Telecaller", "Service Caller"].includes(newRoleLabel)
    if (!shouldShowDiseases) {
      setSelectedDiseases([])
    }
    setSelectedBranch([])
  }

  const handleStatusChange = (selectedOption) => {
    setUser((prev) => ({
      ...prev,
      admin_status: selectedOption ? selectedOption.value : "",
    }))

    setErrors((prev) => ({
      ...prev,
      admin_status: "",
    }))
  }

  const validate = () => {
    const newErrors = {}
    if (!/^[a-zA-Z\s]+$/.test(user.admin_name)) {
      newErrors.admin_name = "Full Name must contain only letters and spaces"
    }
    if (!user.role_id) newErrors.role_id = "Select One Role"

    if (!user.admin_username) newErrors.admin_username = "Enter Username"

    if (!user.admin_mobile.trim()) {
      newErrors.admin_mobile = "Contact Number is required"
    } else if (!/^\d{10}$/.test(user.admin_mobile)) {
      newErrors.admin_mobile = "Contact Number must be 10 digits"
    }
    if (!user.admin_email.trim()) {
      newErrors.admin_email = "Email Address is required"
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(user.admin_email)) {
      newErrors.admin_email = "Enter a valid email address"
    }
    if (!user.admin_status) newErrors.admin_status = "Status is required"
    if (showDiseaseDropdown && selectedDiseases.length === 0) {
      newErrors.disease_ids = "Please select at least one disease"
    }
    if (showBranchDropdown && !selectedBranch) {
      newErrors.branch_id = "Please select at least one branch"
    }
    const selectedRole = roleOptions.find((r) => String(r.value) === String(user.role_id))?.label


    if (["Telecaller", "Service Caller"].includes(selectedRole)) {
      if (!extraFields.dailyCallingCapacity.trim()) {
        newErrors.dailyCallingCapacity = "Daily Calling Capacity is required"
      } else if (isNaN(extraFields.dailyCallingCapacity) || Number(extraFields.dailyCallingCapacity) <= 0) {
        newErrors.dailyCallingCapacity = "Must be a positive number"
      }

      if (selectedRole === "Service Caller") {
        if (!extraFields.maxActivePatients.trim()) {
          newErrors.maxActivePatients = "Maximum Active Patients is required"
        } else if (isNaN(extraFields.maxActivePatients) || Number(extraFields.maxActivePatients) <= 0) {
          newErrors.maxActivePatients = "Must be a positive number"
        }
      }
    }
    if (!editUser) {
      // Required for new users
      if (!user.admin_password) newErrors.admin_password = "Enter password"
      if (!user.admin_cpassword) newErrors.admin_cpassword = "Confirm your password"
      if (user.admin_password !== user.admin_cpassword) {
        newErrors.admin_cpassword = "Passwords do not match"
      }
    } else {
      // Optional for edits, but must match if provided
      if (user.admin_password || user.admin_cpassword) {
        if (user.admin_password.length < 6) {
          newErrors.admin_password = "Password must be at least 6 characters"
        }
        if (user.admin_password !== user.admin_cpassword) {
          newErrors.admin_cpassword = "Passwords do not match"
        }
      }
    }

    setErrors(newErrors)
    return Object.keys(newErrors).length === 0
  }

  const showDiseaseDropdown =
    user.role_id &&
    ["Telecaller", "Service Caller"].includes(roleOptions.find((r) => String(r.value) === String(user.role_id))?.label)

  const handleDiseasesChange = (selectedOptions) => {
    const diseaseIds = selectedOptions ? selectedOptions.map((opt) => String(opt.value)) : []
    setSelectedDiseases(diseaseIds)
    setErrors((prev) => ({
      ...prev,
      disease_ids: "",
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    console.log("Submit button clicked");
    setLoading(true)
    setError("")

    if (!validate()) {
      console.log("validate:", validate);
      setLoading(false)

      return
    }


    if (user.admin_password || user.admin_cpassword) {
      console.log("password:", user.admin_password);
      if (user.admin_password !== user.admin_cpassword) {

        showErrorAlert("Passwords do not match")
        setLoading(false)
        return
      }
    }


    const payload = {
      ...user,
      // admin_status: user.admin_status === "Active" ? true : false,
      enable_2fa: user.enable_2fa ? "Yes" : "No",
      disease_ids: selectedDiseases,
      branch_id: selectedBranch ? [selectedBranch.value] : [],
      daily_calling_capacity: extraFields.dailyCallingCapacity,
      maximum_active_patients: extraFields.maxActivePatients,
    }

    const action = editUser
      ? updateAdminUserAction({
        ...payload,
        edit_admin_id: editUser.admin_id // ✅ separate field
      })
      : addAdminUserAction(payload)

    dispatch(action)
      .then(() => {
        navigate("/users", {
          state: location.state?.returnTo || {}, // pass back pagination/search/sort state
        })
      })
      .catch(() => {
        showErrorAlert(`Failed to ${editUser ? "update" : "add"} user`)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  if (fetching) {
    return (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(255, 255, 255, 0.7)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999,
        }}
      >
        <Loader size="lg" />
      </div>
    )
  }

  return (
    <div className="row">
      <div className="col-xl-12">
        <div className="card">
          <div className="card-body">
            <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "20px" }}>
              <Link to="/users" className="btn btn-link">
                <Button variant="primary">Back</Button>
              </Link>
            </div>
            {error && <div className="text-danger mb-2">{error}</div>}

            <form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Full Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="admin_name"
                    placeholder="Enter Full Name"
                    value={user.admin_name}
                    onChange={handleChange}
                    disabled={isDoctorRole}
                  />
                  {errors.admin_name && <small className="text-danger">{errors.admin_name}</small>}
                </div>
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Email Address</label>
                  <span style={{ color: "red" }}>*</span>
                  <input
                    type="email"
                    className="form-control"
                    name="admin_email"
                    placeholder="Enter Email Address"
                    value={user.admin_email}
                    onChange={handleChange}
                  />
                  {errors.admin_email && <small className="text-danger">{errors.admin_email}</small>}
                </div>
              </div>

              <div className="row">
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Contact Number</label>
                  <span style={{ color: "red" }}>*</span>
                  <input
                    type="tel"
                    className="form-control"
                    name="admin_mobile"
                    maxLength="10"
                    placeholder="Enter Contact Number"
                    value={user.admin_mobile}
                    onChange={handleChange}
                  />
                  {errors.admin_mobile && <small className="text-danger">{errors.admin_mobile}</small>}
                </div>
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Role</label>
                  <span style={{ color: "red" }}>*</span>
                  <Select
                    name="role_id"
                    options={roleOptions}
                    value={roleOptions.find((opt) => String(opt.value) === String(user.role_id)) || null}
                    onChange={handleRoleChange}
                    placeholder="Select Role"
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        minHeight: "50px",
                        height: "50px",
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        lineHeight: "50px",
                      }),
                      dropdownIndicator: (provided) => ({
                        ...provided,
                        padding: "4px",
                      }),
                      indicatorSeparator: (provided) => ({
                        ...provided,
                        display: "none",
                      }),
                    }}
                    isClearable
                  />
                  {errors.role_id && <small className="text-danger">{errors.role_id}</small>}
                </div>
              </div>

              {["Telecaller", "Service Caller"].includes(
                roleOptions.find((r) => String(r.value) === String(user.role_id))?.label,
              ) && (
                  <div className="row">
                    <div className="col-xl-6 mb-3">
                      <label className="form-label">Daily Calling Capacity<span style={{ color: "red" }}>*</span></label>
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Enter Daily Calling Capacity"
                        value={extraFields.dailyCallingCapacity}
                        //min={1}
                        onChange={(e) =>
                          setExtraFields((prev) => ({ ...prev, dailyCallingCapacity: e.target.value }))
                        }
                      />
                      {errors.dailyCallingCapacity && (
                        <small className="text-danger">{errors.dailyCallingCapacity}</small>
                      )}

                    </div>

                    {roleOptions.find((r) => String(r.value) === String(user.role_id))?.label === "Service Caller" && (
                      <div className="col-xl-6 mb-3">
                        <label className="form-label">Maximum Active Patients<span style={{ color: "red" }}>*</span></label>
                        <input
                          type="number"
                          className="form-control"
                          placeholder="Enter Max Active Patients"
                          value={extraFields.maxActivePatients}
                          //min={1}
                          onChange={(e) =>
                            setExtraFields((prev) => ({ ...prev, maxActivePatients: e.target.value }))
                          }
                        />
                        {errors.maxActivePatients && (
                          <small className="text-danger">{errors.maxActivePatients}</small>
                        )}
                      </div>
                    )}
                  </div>
                )}

              <div className="row">
                {showDiseaseDropdown && (
                  <div className="col-xl-6 mb-3">
                    <label className="form-label">
                      Diseases<span style={{ color: "red" }}>*</span>
                    </label>

                    <Select
                      isMulti
                      options={diseases.map((d) => ({
                        value: String(d.disease_id),
                        label: d.disease_name,
                      }))}
                      value={diseases
                        .filter((d) => selectedDiseases.includes(String(d.disease_id)))
                        .map((d) => ({
                          value: String(d.disease_id),
                          label: d.disease_name,
                        }))}
                      onChange={handleDiseasesChange}
                      placeholder="Select Diseases"
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          minHeight: "50px",
                        }),
                        multiValue: (provided) => ({
                          ...provided,
                          backgroundColor: "#f0f0f0",
                        }),
                        dropdownIndicator: (provided) => ({
                          ...provided,
                          padding: "4px",
                        }),
                        indicatorSeparator: () => ({ display: "none" }),
                      }}
                    />
                    {errors.disease_id && <small className="text-danger">{errors.disease_id}</small>}
                  </div>
                )}
              </div>

              <div className="row">
                {/* Status Select */}
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Status</label>
                  <span style={{ color: "red" }}>*</span>
                  <Select
                    name="admin_status"
                    options={statusOptions}
                    value={statusOptions.find(opt => opt.value === user.admin_status) || null}
                    onChange={handleStatusChange}
                    placeholder="Select Status"
                    styles={{
                      control: (provided) => ({ ...provided, minHeight: "50px", height: "50px" }),
                      singleValue: (provided) => ({ ...provided, lineHeight: "50px" }),
                      dropdownIndicator: (provided) => ({ ...provided, padding: "4px" }),
                      indicatorSeparator: (provided) => ({ ...provided, display: "none" }),
                    }}
                    isClearable
                  />
                  {errors.admin_status && <small className="text-danger">{errors.admin_status}</small>}
                </div>

                {/* {showBranchDropdown && ( */}
                <div className="col-xl-6 mb-3">
                  <label className="form-label">
                    Branch<span style={{ color: "red" }}>*</span>
                  </label>

                  <Select
                    options={branchOptions}
                    value={selectedBranch}
                    // onChange={(selected) => setSelectedBranch(selected)}
                    onChange={(selected) => {
                      setSelectedBranch(selected)
                    
                      setErrors((prev) => ({
                        ...prev,
                        branch_id: "",
                      }))
                    }}
                    placeholder="Select Branch"
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        minHeight: "50px",
                      }),
                      multiValue: (provided) => ({
                        ...provided,
                        backgroundColor: "#f0f0f0",
                      }),
                      dropdownIndicator: (provided) => ({
                        ...provided,
                        padding: "4px",
                      }),
                      indicatorSeparator: () => ({ display: "none" }),
                    }}
                  />
                  {errors.branch_id && <small className="text-danger">{errors.branch_id}</small>}
                </div>
                {/* )} */}
              </div>
              <div className="row">
                <div className="col-xl-3 mb-3">
                  <label className="form-label">Username</label>
                  <span style={{ color: "red" }}>*</span>
                  <input
                    type="text"
                    className="form-control"
                    name="admin_username"
                    placeholder="Enter Username"
                    value={user.admin_username}
                    onChange={handleChange}
                    disabled={!!editUser} // disable username edit on update
                  />
                  {errors.admin_username && <small className="text-danger">{errors.admin_username}</small>}
                </div>
                <div className="col-xl-3 mb-3">
                  <label className="form-label">Password {editUser ? "(leave blank to keep current)" : ""}</label>
                  {!editUser && <span style={{ color: "red" }}>*</span>}
                  <div style={{ position: "relative" }}>
                    <input
                      type={showPassword ? "text" : "password"}
                      className="form-control"
                      name="admin_password"
                      placeholder="Enter Password"
                      value={user.admin_password}
                      onChange={handleChange}
                    />
                    <span
                      onClick={() => setShowPassword((prev) => !prev)}
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: "10px",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "#888",
                        //zIndex: 1,
                      }}
                    >
                      {showPassword ? <FaEye /> : <FaEyeSlash />}
                    </span>
                  </div>

                  {errors.admin_password && <small className="text-danger">{errors.admin_password}</small>}
                </div>

                {/* Confirm Password */}
                <div className="col-xl-4 mb-3">
                  <label className="form-label">
                    Confirm Password {editUser ? "(leave blank to keep current)" : ""}
                  </label>
                  {!editUser && <span style={{ color: "red" }}>*</span>}
                  <div style={{ position: "relative" }}>
                    <input
                      type={showCPassword ? "text" : "password"}
                      className="form-control"
                      name="admin_cpassword"
                      placeholder="Enter Password"
                      value={user.admin_cpassword}
                      onChange={handleChange}
                    />
                    <span
                      onClick={() => setShowCPassword((prev) => !prev)}
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: "10px",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "#888",
                      }}
                    >
                      {showCPassword ? <FaEye /> : <FaEyeSlash />}
                    </span>
                  </div>
                  {errors.admin_cpassword && <small className="text-danger">{errors.admin_cpassword}</small>}
                </div>
                <div className="col-xl-2 mb-3 d-flex align-items-end">
                  <div className="form-check mb-2">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name="enable_2fa"
                      id="enable_2fa"
                      checked={!!user.enable_2fa}
                      onChange={handleChange}
                    />
                    <label className="form-check-label" htmlFor="enable_2fa">
                      Enable 2FA
                    </label>
                  </div>
                </div>
              </div>

              {/* <div className="row">
                <div className="col-xl-6 mb-3">
                  <label className="form-label">Status</label>
                  <span style={{ color: "red" }}>*</span>
                  <Select
                    name="admin_status"
                    options={statusOptions}
                    value={statusOptions.find((opt) => opt.value === user.admin_status) || null}
                    onChange={handleStatusChange}
                    placeholder="Select Status"
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        minHeight: "50px",
                        height: "50px",
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        lineHeight: "50px",
                      }),
                      dropdownIndicator: (provided) => ({
                        ...provided,
                        padding: "4px",
                      }),
                      indicatorSeparator: (provided) => ({
                        ...provided,
                        display: "none",
                      }),
                    }}
                    isClearable
                  />
                  {errors.admin_status && <small className="text-danger">{errors.admin_status}</small>}
                </div>
                <div className="col-xl-2 mb-3">
    <div className="form-check mt-4">
      <input
        type="checkbox"
        className="form-check-input"
        name="two_factor_auth"
        id="two_factor_auth"
        checked={!!enable2FA} // ensure boolean
        onChange={(e) => setEnable2FA(e.target.checked)}
      />
      <label className="form-check-label" htmlFor="two_factor_auth">
        Enable 2FA
      </label>
    </div>
  </div>
                <div className="col-xl-4 mb-3">
                  <label className="form-label">
                    Confirm Password {editUser ? "(leave blank to keep current)" : ""}
                  </label>
                  {!editUser && <span style={{ color: "red" }}>*</span>}
                  <div style={{ position: "relative" }}>
                    <input
                      type={showCPassword ? "text" : "password"}
                      className="form-control"
                      name="admin_cpassword"
                      placeholder="Enter Password"
                      value={user.admin_cpassword}
                      onChange={handleChange}
                    />
                    <span
                      onClick={() => setShowCPassword((prev) => !prev)}
                      style={{
                        position: "absolute",
                        top: "50%",
                        right: "10px",
                        transform: "translateY(-50%)",
                        cursor: "pointer",
                        color: "#888",
                        //zIndex: 1,
                      }}
                    >
                      {showCPassword ? <FaEye /> : <FaEyeSlash />}
                    </span>
                  </div>

                </div>
                
              </div> */}


              <button type="submit" className="btn btn-primary" disabled={loading || fetching}>
                {loading ? (
                  <>
                    <Loader size="sm" />
                    <span className="ms-2">Submitting...</span>
                  </>
                ) : (
                  <>{editUser ? "Update User" : "Add User"}</>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddUser;
